module.exports = __webpack_public_path__ + "img/fruit-currants-190x100.3c67d1b0.jpg";